export default "__VITE_ASSET__DRc3enej__"